<template>
  <div id="courseCenter">
    <Button @click="addClassify" type="primary">新增分类</Button>
    <div class="content">
      <Table :loading="loading" ref="selection" :columns="columns4" :data="classify">
        <template slot-scope="{ row }" slot="action">
          <Button @click="editClassify(row)" type="text" size="small">编辑</Button>-
          <Button @click="deleteClassify(row)" type="text" size="small">删除</Button>
        </template>
      </Table>
    </div>
    <Modal v-model="addClassifyModal" :title="modalText" ref="modal">
      <div class="course-type">
        <Form :rules="ruleValidate" :model="addClassifyInfo" :label-width="80">
          <FormItem label="所属分类" v-if="parent_name">
            <p>{{parent_name}}</p>
          </FormItem>
          <FormItem label="分类名称" prop="name">
            <Input style="width:300px" type="text" v-model="addClassifyInfo.name" clearable />
          </FormItem>
          <FormItem label="排序" prop="sort">
            <Input type="text" style="width:300px" v-model="addClassifyInfo.sort" clearable />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="addClassifyModal = false">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import expandRow from "./ExpandRow";
export default {
  name: "NewsCatagory",
  data() {
    return {
      loading: false,
      addClassifyModal: false,
      modalText: "新增分类",
      searchKey: "",
      expandId: "",
      ruleValidate: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        sort: [{ required: true, message: "请输入" }]
      },
      value2: ["2016-01-01", "2016-02-15"],
      columns4: [
        {
          title: "分类名称",
          key: "name",
          minWidth: 160,
          align: "center"
        },
        {
          title: "排序",
          key: "sort",
          align: "center",
          minWidth: 100
        },
        {
          title: "操作",
          slot: "action",
          key: "address",
          minWidth: 120,
          align: "center",
          fixed: "right"
        }
      ],
      classify: [],
      checkCourse: [],
      addClassifyInfo: {},
      parent_id: "0",
      parent_name: ""
    };
  },
  created() {
    this.getClassify();
  },
  mounted() {},
  methods: {
    addClassify(row) {
      if (row) {
        this.parent_id = row.id;
        this.parent_name = row.name;
      } else {
        this.parent_id = "0";
        this.parent_name = "";
      }
      this.addClassifyInfo = {};
      this.modalText = "新增分类";
      this.addClassifyModal = true;
    },
    editClassify(row) {
      this.addClassifyInfo = {};
      this.modalText = "编辑分类";
      this.addClassifyInfo.name = row.name;
      this.addClassifyInfo.sort = row.sort;
      this.id = row.id;
      this.addClassifyModal = true;
    },
    deleteClassify(row) {
      if (row.hasOwnProperty("children") && row.children.length > 0) {
        this.$Modal.warning({
          title: "提示",
          content: "<p>当前分类下含有子分类，无法删除</p>"
        });
        return;
      }
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要删除该分类吗</p>",
        onOk: () => {
          this.$http.delete("/api/informationClassify/" + row.id).then(() => {
            this.getClassify();
          });
        },
        onCancel: () => {}
      });
    },
    save() {
      if (!this.addClassifyInfo.name) {
        this.$Message.error("分类名称必填！");
        this.$refs.modal.visible = true;
        return;
      }
      if (this.modalText == "新增分类") {
        this.$http
          .post("/api/informationClassify", {
            name: this.addClassifyInfo.name,
            parent_id: 0,
            sort: this.addClassifyInfo.sort
          })
          .then(() => {
            this.addClassifyModal = false;
            this.getClassify();
          });
      } else {
        this.$http
          .put(`/api/informationClassify/${this.id}`, {
            name: this.addClassifyInfo.name,
            parent_id: 0,
            sort: this.addClassifyInfo.sort
          })
          .then(() => {
            this.addClassifyModal = false;
            this.getClassify();
          });
      }
    },
    getClassify() {
      this.loading = true;
      this.$http.get("/api/informationClassify").then(res => {
        this.loading = false;
        let flag = 0;
        res.forEach(i => {
          if (i.parent_id != 0) {
            flag = 1;
            for (let j = 0; j < res.length; j++) {
              if (res[j].id == i.parent_id) {
                if (!res[j].hasOwnProperty("children")) {
                  res[j].children = [];
                }
                res[j].children.push(i);
                break;
              }
            }
          }
        });
        if (flag) {
          if (this.columns4[0].type != "expand") {
            this.columns4.unshift({
              type: "expand",
              align: "center",
              width: "30",
              render: (h, params) => {
                return h(expandRow, {
                  props: {
                    row: params.row
                  },
                  on: {
                    refreshData: val => {
                      this.expandId = val;
                      this.getClassify();
                    },
                    onEdit: row => {
                      this.editClassify(row);
                    },
                    onDelete: row => {
                      this.deleteClassify(row);
                    }
                  }
                });
              }
            });
          }
        }
        let newRes = [];
        res.forEach(item => {
          if (item.parent_id == 0) {
            if (!item.hasOwnProperty("children")) {
              item._disableExpand = true;
            }
            if (item.id == this.expandId) {
              item._expanded = true;
            }
            newRes.push(item);
          }
        });
        this.classify = newRes;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#courseCenter {
  padding: 15px;
  background-color: #fff;
  height: calc(100vh - 130px);
  .content {
    margin-top: 15px;
  }
  .button-group {
    margin-top: 15px;
    float: left;
  }
}
.course-type {
  font-size: 16px;
  padding: 10px;
}
.ivu-table-expanded-cell {
  padding: 0 !important;
}
</style>
